import { render, staticRenderFns } from "./videos.vue?vue&type=template&id=4f389be4"
import script from "./videos.vue?vue&type=script&lang=js"
export * from "./videos.vue?vue&type=script&lang=js"
import style0 from "./videos.vue?vue&type=style&index=0&id=4f389be4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports